import React, { useRef, useState, useEffect } from 'react';
import {
  stripHtml,
  correctUrlFormatForRouting,
  pushSearchSuggestionClickEvent,
} from '../../../util/DataUtil';
import { sendClickedObjectIDsAfterSearch } from '../../../util/AlgoliaInsights';
import { SearchBarPlacement } from '../../../constants/SearchBarPlacement';

const SuggestionItem = ({
  item,
  type,
  screenWidth,
  router,
  setSearchActive,
  setSearchInputValue,
  searchInputValue,
  resultPosition,
  queryID,
  indexName,
}) => {
  const wrapperRef = useRef(null);
  const [wrapperHeight, setWrapperHeight] = useState(0);

  useEffect(() => {
    if (wrapperRef.current) {
      setWrapperHeight(wrapperRef.current.offsetHeight);
    }
  }, [screenWidth, item]);
  const finalHeight = wrapperHeight > 100 ? 100 : wrapperHeight;
  const imageContainerStyle = {
    flex: `0 0 ${finalHeight}px`,
  };

  return (
    <div
      onClick={() => {
        pushSearchSuggestionClickEvent(
          searchInputValue.toLowerCase(),
          SearchBarPlacement.NAVIGATION,
          item?.field_display_title ? item?.field_display_title : item?.title,
          resultPosition
        );
        sendClickedObjectIDsAfterSearch(
          queryID,
          item?.objectID,
          indexName,
          resultPosition
        );
        setSearchInputValue('');
        setSearchActive(false);

        const cleanUrl = correctUrlFormatForRouting(item?.url);
        // window.location.href = cleanUrl.url;
        router.push({
          pathname: cleanUrl.url,
        });
      }}
      className={`suggestion-item ${item?.title?.length > 60 && screenWidth < 1555 ? 'wrap-down' : ''}`}
    >
      {type === '/ Author' && (
        <div
          className="suggestion-item-author-image"
          style={imageContainerStyle}
        >
          <img
            src={
              item?.field_author_photo
                ? `https://res.cloudinary.com/digitalrealty/image/upload/${item.field_author_photo}.jpg`
                : `/images/featured-author.png`
            }
            alt={item?.field_author_photo || 'Author image'}
          />
        </div>
      )}
      <div className="suggestion-item-wrapper" ref={wrapperRef}>
        <div
          className={`suggestion-item-top-wrapper ${item?.title?.length > 105 && !item?.field_slug && !item?.field_intro ? 'display-block' : ''}`}
        >
          <span className="suggestion-item-title">
            {item?.field_display_title
              ? item?.field_display_title
              : item?.title}{' '}
          </span>
          <p className="author-title"> {item?.field_author_title}</p>
          <span className="suggestion-item-type">{type}</span>
        </div>
        {
          <p className="suggestion-item-description">
            {type == '/ Author'
              ? stripHtml(
                  item?.field_description
                    ? item.field_description.split('.')[0] +
                        (item.field_description.includes('.') ? '.' : '')
                    : item?.field_slug || ''
                )
              : item?.field_slug
                ? stripHtml(item?.field_slug)
                : stripHtml(item?.field_intro)}
          </p>
        }
      </div>
    </div>
  );
};

export default SuggestionItem;
